module.exports = __webpack_public_path__ + "static/media/S__11010051.97c316cf.jpg";